import { Control } from "../Control";

//     var el = domvm.defineElement;

export class DropdownButton extends Control {

    constructor(parent, params = {}) {

        params = Object.assign({
            controls: [],
            expanded: false,
            autoclose: false,
        }, params || {});

        super(parent, params);

        const {
            label = null,
            icon = null,
            controls = [],
            buttonCss = null,
            menuCss = null,
            anchor = null,
            expanded = false,
            autoclose = false,
            onOpen = () => { },
            onClose = () => { },
        } = params;

        this.label = label;
        this.icon = icon;
        this.controls = controls;
        this.buttonCss = buttonCss;
        this.menuCss = menuCss;
        this.anchor = anchor;
        this.expanded = expanded;
        this.autoclose = autoclose;
        this.onOpen = onOpen;
        this.onClose = onClose;

    };

    getLabel() {
        return (typeof this.label === 'function' ? this.label.call(this) : this.label);
    };

    getIcon() {
        return (typeof this.icon === 'function' ? this.icon.call(this) : this.icon);
    };

    isExpanded() {
        return (typeof this.expanded === 'function' ? this.expanded() : this.expanded);
    };

    isAutoclose() {
        return (typeof this.autoclose === 'function' ? this.autoclose() : this.autoclose);
    };

    getControls() {
        return (typeof this.controls === 'function' ? this.controls.call(this) : this.controls);
    };

    getButtonCss() {
        return (typeof this.buttonCss === 'function' ? this.buttonCss.call(this) : this.buttonCss);
    };

    getMenuCss() {
        return (typeof this.menuCss === 'function' ? this.menuCss.call(this) : this.menuCss);
    };

    getAnchor() {
        return (typeof this.anchor === 'function' ? this.anchor.call(this) : this.anchor);
    };

    // ------------------------------------------------------------------------

    open() {
        this.expanded = true;
        this.onOpen();
        this.invalidate();
    };

    close() {
        this.expanded = false;
        this.onClose();
        this.invalidate();
    };

    toggle() {
        if (this.expanded)
            this.close();
        else
            this.open();
    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var readOnlyOrDisabled = this.isReadOnly() || this.isDisabled();

        return renderer.dropdownButton(
            this.getLabel(),
            this.getIcon(),
            {
                css: this.getCss(),
                buttonCss: this.getButtonCss(),
                menuCss: this.getMenuCss(),
                anchor: this.getAnchor(),
                props: {
                    disabled: readOnlyOrDisabled ? 'disabled' : null,
                },
                expanded: this.isExpanded(),
                autoclose: this.isAutoclose(),
            },
            this.getControls().map(control => control.render(renderer, vm))
        );

    };

}